// extracted by mini-css-extract-plugin
module.exports = {"sideSheetCatalogue":"Aside_sideSheetCatalogue__qXqbG"};